export default __webpack_public_path__ + "static/media/lock.9d2eb079.svg";